import React from "react";
import { valueToString } from "helpers/Helpers";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function TeeTimePromotionsTable(props: IProps) {
  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value);
    }

    return newValue;
  }

  function cellData(columnId: string, cellValue: string, displayType: string) {
    switch (columnId) {
      case "original_price":
      case "net_price":
      case "saved":
        return formatDisplay("currency", cellValue);
      default:
        return formatDisplay(displayType, cellValue);
    }
  }

  function rowClassNames(row: any) {
    return classNames({
      "report-table-row": !row.original?.subRows,
      "report-table-row-total": !!row.original?.subRows,
    });
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    const original = cell.row?.original;
    const isClickableRow = !cell.isGrouped && !cell.isAggregated;

    return classNames({
      "report-table-row-locked": isRowLocked,
      "report-table-cell-clickable":
        isClickableRow &&
        ((cell.column.id === "player_name" && original?.customer_id) ||
          (cell.column.id === "tee_time" && original?.tee_time_id)),
    });
  }

  function cellOnClick(cell: any) {
    if (!cell || cell.isGrouped || cell.isAggregated) {
      return null;
    }

    const original = cell.row?.original;

    if (cell.column.id === "player_name" && original?.customer_id) {
      return window.open(`/admin/customers/${String(original.customer_id)}/profile`);
    }

    if (cell.column.id === "tee_time" && original?.tee_time_id) {
      return window.open(`/admin/teesheet/details/${String(original.tee_time_id)}`);
    }

    return null;
  }

  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }

    switch (columnId) {
      case "original_price":
      case "net_price":
      case "saved":
        return formatDisplay("currency", String(footerRow[columnId] ?? 0));
      default:
        return (footerRow[columnId] as string) ?? null;
    }
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      rowClassNames={rowClassNames}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={true}
      expandingColumn="type"
    />
  );
}
